module.exports = "../../../../platform/assets/pageMainIcon/danjuweihulei4.svg";